import React from 'react';

const SlotCard = ({ slot, selectedSlot, handleSlotSelection }) => {
  const isSelected = selectedSlot === `${slot.startTime} - ${slot.endTime}`;

  return (
    <div
      className={`p-1 border rounded-md cursor-pointer ${
        isSelected ? 'bg-blue-500 text-white' : 'bg-gray-100 text-black'
      }`}
      onClick={() => handleSlotSelection(slot)}
      style={{
        fontSize: '0.675rem', // Smaller font size
        lineHeight: '1.10rem', // Adjust line height
        width: '100px', // Set a smaller width
        maxWidth: '100%', // Ensure it doesn't exceed the container
      }}
    >
      <h3 className="text-md font-semibold">
        {slot.startTime} - {slot.endTime}
      </h3>
      <p className="mt-1">Price: ₹{slot.price}</p>
    </div>
  );
};

export default SlotCard;
